import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface IInfoSectionProps {
  variant: 'success' | 'error';
  children: ReactNode;
  addition?: ReactNode;
}

const InfoSection: FC<IInfoSectionProps> = ({
  variant,
  children,
  addition,
}) => {
  return (
    <section className={'flex flex-col gap-10 w-full'}>
      <div
        className={cn(
          'border p-8 rounded-xl',
          { 'border-orange bg-orange-light': variant === 'error' },
          { 'border-green bg-green-light': variant === 'success' }
        )}
      >
        {children}
      </div>
      <>{addition}</>
    </section>
  );
};

export default InfoSection;
